import { ButtonProps, CircularProgress } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useFormState } from 'react-hook-form';
import { SubmitButton } from '../../atom/button/SubmitButton';

export type SubmitButtonProps = Omit<ButtonProps, 'type' | 'onClick'> & {
  color?: ButtonProps['color'];
  isSubmitting?: boolean;
  allowSubmitPristine?: boolean;
};

const FormSubmitButton: FC<PropsWithChildren<SubmitButtonProps>> = ({ allowSubmitPristine, children, disabled, ...rest }) => {
  const { isSubmitting, isDirty } = useFormState();

  return (
    <SubmitButton disabled={(!isDirty && !allowSubmitPristine) || isSubmitting || disabled} {...rest}>
      {children}
      {isSubmitting && <CircularProgress size={20} sx={{ marginLeft: '1em' }} />}
    </SubmitButton>
  );
};

export default FormSubmitButton;
